// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"CS-z","inlineTitle":"DS-z","sponsoredAdsWrapper":"ES-z","marketplaceRecosWrapper":"FS-z"};